module.exports = __webpack_public_path__ + "img/Karatedo.jpg";